<template>
  <q-dialog v-model="visible">
    <q-card>
      <q-progress
        :percentage="percentCompleted"
        style="height: 4px"
      />
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-2">
            <img :src="file">
          </div>
          <div class="col-md-8">
            <input type="file" @change="onFileChange" class="form-control" ref="fileupload">
          </div>
          <div class="col-md-2">
            <q-btn @click="upload">Upload</q-btn>
          </div>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<style scoped>
  img{
    max-height: 36px;
  }
</style>

<script>

import firestore from '../store/firestore'

export default {
  data () {
    return {
      file: null,
      percentCompleted: 0.0,
      uploadPromise: null,
      callback: null,
      itemId: null,
      visible: false,
      promise: null,
      resolvePromise: null,
      rejectPromise: null
    }
  },
  methods: {
    show (itemId) {
      this.itemId = itemId
      this.percentCompleted = 0.0
      this.visible = true
      let t = this
      return new Promise((resolve, reject) => {
        t.resolvePromise = resolve
        t.rejectPromise = reject
      })
    },
    // chooseFile (noteId, callback) {
    //   console.log('choose file')
    //   this.noteId = noteId
    //   this.callback = callback
    //   this.$refs.fileupload.click()
    // },
    onFileChange (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.files = files[0]
      this.upload()
    },
    upload () {
      let t = this
      let file = this.$refs.fileupload.files[0]

      let uploadTask = firestore.storage.ref('users/' + this.$store.state.auth.currentUser.uid + '/' + file.name).put(file)

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on('state_changed', (snapshot) => {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        t.percentCompleted = (snapshot.bytesTransferred / snapshot.totalBytes) * 100.0
        // console.log('Upload is ' + t.percentCompleted + '% done')
        // switch (snapshot.state) {
        //   case firebase.storage.TaskState.PAUSED: // or 'paused'
        //     console.log('Upload is paused')
        //     break
        //   case firebase.storage.TaskState.RUNNING: // or 'running'
        //     console.log('Upload is running')
        //     break
        // }
      }, (error) => {
        // Handle unsuccessful uploads
        t.rejectPromise(error)
      }, () => {
        // Handle successful uploads on complete
        t.resolvePromise(file.name)
        t.visible = false
      })
    }
  }
}
</script>
